import { Button, Card,Container, Box,CircularProgress, CardContent, Grid, Typography } from "@mui/material";
import { useNavigate, useParams,useSearchParams,useLocation } from "react-router-dom";
import { SUBSCRIPTION_PLANS } from "../../shared/constants.js";
import { PaymentAPIService } from "../../services/api/PaymentAPIService.js";
import starIcon from "../../assests/Images/starIcon.png";
import lineIcon from "../../assests/Images/lineIcon2.png";
import joyLogo from "../../assests/Images/joyLogo.png";
import { useState } from "react";

export default function Plans() {
  const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const paymentType = searchParams.get("type");
     const location = useLocation();
    const isAdminRoute = location.pathname.includes("/admin");

  const { phoneNumber: phone } = useParams();
  const [loading, setLoading] = useState(false); // stores the plan key being loaded


  async function handlePay(e, amount, planName,priceId) {
    e.preventDefault();
    setLoading(true)

    const { url, error } = await PaymentAPIService.checkout({ phone, amount, planName,priceId });
    if (error)
    {
        setLoading(false)
        return alert(error);
    }

    window.location.href = url;
  }

  return (
    <>
    {loading ?
         <Box
         height="100vh"
         display="flex"
         justifyContent="center"
         alignItems="center"
         flexDirection="column"
       >

             <CircularProgress />
             <Typography mt={2} sx={{textAlignLast:"center"}}>Redirecting, please wait...
             <br />
             Please don’t refresh or close this tab.
             </Typography>
       </Box>
        :
    <Container sx={{ marginTop: 1,marginBottom: 4 }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <img src={starIcon} alt="Star Icon" style={{ width: 60, height: "auto",marginTop:"40px" }} />
        <img src={joyLogo} alt="Joy Logo" style={{ width: 120, height: "auto" }} />
        <img src={lineIcon} alt="Line Icon" style={{ width: 60, height: "auto" ,marginTop:"40px"}} />
      </Box>
    <Grid
      container
      direction="row"
      spacing={{ xs: 2, md: 3 }}
      columns={{ xs: 4, sm: 8, md: 12 }}
      sx={{
        position: "relative",
        justifyContent: "space-evenly",
        alignItems: "center",
        top: "74px",
        paddingBottom: "60px",
      }}
    >
      {Object.entries(SUBSCRIPTION_PLANS).map(([key, plan]) => (

        plan.type === "all" || plan.type === paymentType || isAdminRoute ?
        <Grid item key={key} xs={12} sm={6} md={5}>
          <Card sx={{ }}>
            <CardContent>
              <Typography variant="h5"><b>${plan.amount} / {plan.label} <span style={{fontSize:"12px"}}>{plan.offer}</span></b></Typography>
              {/* <Typography gutterBottom>Includes 14-day free trial</Typography> */}

              <ul style={{ paddingLeft: "16px", marginTop: "10px", marginBottom: "10px" }}>
                <li><Typography variant="body2">Cancel anytime</Typography></li>
                <li><Typography variant="body2">Get access to your personal 24x7 pregnancy coach</Typography></li>
                <li><Typography variant="body2">Countdown to your baby’s birth</Typography></li>
                <li><Typography variant="body2">Learn about your growing baby & body</Typography></li>
                <li><Typography variant="body2">Get personalized answers to all your questions</Typography></li>
                <li><Typography variant="body2">Manage your to-do lists better</Typography></li>
                <li><Typography variant="body2">Save time & money with your personal shopper</Typography></li>
              </ul>

              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 2 }}
                onClick={(e) => !isAdminRoute &&handlePay(e, plan.amount, plan.mode,plan.priceId)}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : `Subscribe`}
              </Button>
            </CardContent>
          </Card>
        </Grid>
        :""

      ))}
    </Grid>
    </Container>
    }
    </>
  );
}
